export enum LDFlags {
    HOME_PAGE = 'Lab-LP-EndMyAutoLease-HomePage'
}
  
export type FlagOverrides = {
[key in LDFlags]?: unknown;
};
  